import { zodResolver } from '@hookform/resolvers/zod';
import { bankSchema, type Bank } from '@pgs/shared';
import { useForm } from 'react-hook-form';
import { focusFirstError } from '../focusFirstError';
import { NavButtons } from '../NavButtons';
import { StepPanel } from '../StepPanel';
import { NameInput } from '@/components/form/NameInput';
import { SortCodeInput } from '@/components/form/SortCodeInput';
import { TextField } from '@/components/form/TextField';

interface Props {
  defaultValues?: Partial<Bank>;
  onBack: () => void;
  onSubmit: (values: Bank) => void;
}

export const Step3Bank = ({ defaultValues, onBack, onSubmit }: Props) => {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<Bank>({
    resolver: zodResolver(bankSchema),
    defaultValues,
    mode: 'onBlur',
  });

  return (
    <StepPanel
      icon="fa-university"
      title="Your Bank Details"
      description={
        <>
          <strong className="text-teal">*</strong> This is the account we will pay your wages into.
        </>
      }
    >
      <form onSubmit={handleSubmit(onSubmit, focusFirstError)}>
        <NameInput control={control} name="bankName" label="Bank / Building Society Name" />
        <NameInput control={control} name="accountName" label="Account Name" />
        <TextField
          label="Account Number"
          maxLength={8}
          placeholder="8 digits"
          inputMode="numeric"
          {...register('accountNumber')}
          error={errors.accountNumber?.message}
        />
        <SortCodeInput control={control} name="sortCode" label="Sort Code" />
        <NavButtons onBack={onBack} submit />
      </form>
    </StepPanel>
  );
};
